import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { MapPin, Clock, Car } from 'lucide-react';

const meetingSchedule = [
  { month: 'September', day: 'Third Saturday', time: '10:30 (12:30)', info: 'Regular Meeting' },
  { month: 'October', day: 'Third Saturday', time: '10:30 (12:30)', info: 'Regular Meeting' },
  { month: 'November', day: 'Third Saturday', time: '10:30 (12:30)', info: 'Regular Meeting' },
  { month: 'January', day: 'Third Saturday', time: '10:30 (12:30)', info: 'Regular Meeting' },
  { month: 'February', day: 'Third Saturday', time: '10:30 (12:30)', info: 'Regular Meeting' },
  { month: 'March', day: 'Second Saturday', time: '16:00', info: 'Wreath-Laying at the Scott Monument' },
  { month: 'March', day: 'Second Saturday', time: '17:30 (18:00)', info: "Scott Night - Dinner to commemorate Sir Walter Scott's Initiation into the Lodge" },
  { month: 'March', day: 'Third Saturday', time: '10:30 (12:30)', info: 'Installation of Office-Bearers' },
  { month: 'April', day: 'Third Saturday', time: '10:30 (12:30)', info: 'Regular Meeting' },
];

const MeetingsPage = () => {
  return (
    <div className="p-6 md:p-12 lg:p-16" data-testid="meetings-page">
      <div className="max-w-4xl">
        <h1 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          Meetings
        </h1>

        {/* Meeting Times */}
        <section className="mb-10" data-testid="meeting-times-section">
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            The Lodge meets at 10.30 am on the third Saturday of each month from September to November
            and January to April (inclusive). The Scott Night in 2025 will be held on the second Saturday in March.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            The dress code is lounge suit (black or dark blue/grey suit, white shirt, and tie).
            Office-bearers wear black tie (dinner jacket and black bow tie).
          </p>
        </section>

        {/* Dining Information */}
        <section className="mb-10" data-testid="dining-section">
          <Card className="border-gray-100">
            <CardContent className="p-6">
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Meetings are followed by a three-course white-table lunch for a dining fee of
                £20 for members and £15 for visitors. Alcoholic and non-alcoholic drinks can be
                purchased from the subsidized bar.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                The final (Tyler's) toast is typically around 2:30pm with the day finished by 3:00 pm.
              </p>
            </CardContent>
          </Card>
        </section>

        {/* Location */}
        <section className="mb-10" data-testid="location-section">
          <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Location</h2>
          <Card className="border-gray-100 bg-gradient-to-br from-gray-50 to-white">
            <CardContent className="p-6">
              <div className="flex items-start gap-4 mb-4">
                <MapPin className="h-6 w-6 text-emerald-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium text-gray-900">The Lodge of Edinburgh (Mary's Chapel) No. 1</p>
                  <p className="text-gray-600">19 Hill Street, EDINBURGH, EH2 3JP</p>
                </div>
              </div>
              <div className="flex items-start gap-4 mb-4">
                <Clock className="h-6 w-6 text-emerald-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-gray-700">
                    Three-minute walk from Princes Street, which is well served by public buses and taxis;
                    and a ten-minute walk from Waverley Train Station.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Car className="h-6 w-6 text-emerald-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-gray-700">
                    There is no dedicated car parking, but on-street metered parking is widely available
                    within a short walking distance.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </section>

        {/* Schedule Table */}
        <section data-testid="schedule-section">
          <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Meeting Schedule</h2>
          <Card className="border-gray-100 overflow-hidden">
            <CardContent className="p-0">
              <div className="overflow-x-auto">
                <Table>
                  <TableHeader>
                    <TableRow className="bg-gray-50">
                      <TableHead className="font-semibold">Month</TableHead>
                      <TableHead className="font-semibold">Day</TableHead>
                      <TableHead className="font-semibold">Time (Meal)</TableHead>
                      <TableHead className="font-semibold">Meeting Information</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {meetingSchedule.map((meeting, index) => (
                      <TableRow key={index} data-testid={`meeting-row-${index}`}>
                        <TableCell className="font-medium">{meeting.month}</TableCell>
                        <TableCell>{meeting.day}</TableCell>
                        <TableCell>{meeting.time}</TableCell>
                        <TableCell className="text-gray-600">{meeting.info}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>
        </section>
      </div>
    </div >
  );
};

export default MeetingsPage;
